import React, { useReducer, createContext } from 'react';
import { object, node } from 'prop-types';
import { reducer } from './reducer';

const AppContext = createContext();

const AppProvider = ({ seller, gig, assetsSharing, children }) => {
    const initialState = {
        seller,
        gig,
        assetsSharing,
    };

    const [appState, dispatch] = useReducer(reducer, initialState);

    return <AppContext.Provider value={{ ...appState, dispatch }}>{children}</AppContext.Provider>;
};

export { AppProvider, AppContext };

AppProvider.propTypes = {
    seller: object,
    gig: object,
    assetsSharing: object,
    children: node.isRequired,
};

export default AppContext;
